import React, {useState, useRef, useEffect} from 'react';
import Card from "../Card";
import Filter from "../datatable/Filter";
import Button from "../Button";
import SearchInput from "../datatable/SearchInput";
import axios from "axios";
import {toast} from "react-toastify";
import Tile from "./components/Tile";
import NoFiles from "./components/NoFiles";
import {useDebounce} from "../../helpers/DebounceHelper";
import UploadFileModal from "../../modals/UploadFileModal";
import {uploadToServer} from "../../helpers/FIleHelper";
import DeleteFileModal from "../../modals/DeleteFileModal";

const FileGallery = (props) => {
    const {
        getRoute,
        uploadRoute,
        deleteRoute,
        noPadding   = false,
        parentId,
    } = props;

    const [uploadFileModal, setUploadFileModal] = useState(false);
    const [deleteFileModal, setDeleteFileModal] = useState(false);
    const [search, setSearch]                   = useState("");
    const [files, setFiles]                     = useState([]);

    useEffect(() => {
        load();
    }, [search]);

    const [searchTerm, setSearchTerm] = useState(search);
    const invokeDebounced = useDebounce(
        () => setSearch(searchTerm),
        750
    );
    useEffect(invokeDebounced, [searchTerm]);

    const load = () => {
        axios.get(getRoute+'?search='+search)
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.files) {
                        setFiles(response.data.files);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const upload = (newFiles) => {
        axios.post(uploadRoute, {
            files:  newFiles.map((item) => uploadToServer(item))
        })
            .then((response) => {
                load();

                toast.success(<div>{!!response.data.message ? response.data.message : "Documents Uploaded"}</div>);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }
            });
    }

    const deleteFile = (file) => {
        axios.post(deleteRoute, {
            file:  uploadToServer(file)
        })
            .then((response) => {
                load();

                toast.success(<div>{!!response.data.message ? response.data.message : "Documents Deleted"}</div>);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }
            });
    }

    const handleFilesUpload = (newFiles) => {
        upload(newFiles);
        setUploadFileModal(false);
    }

    const handleFileDelete = (file) => {
        deleteFile(file);
        setDeleteFileModal(false);
    }

    return (
        <Card classes={"border-0"} noPadding={noPadding}>
            <div className={"row m-0 mb-4 p-0 d-flex justify-content-xl-between"}>
                <div className="col-12 col-xl-6 m-0 mb-3 mb-xl-0 p-0 pl-xl-2 order-xl-2">
                    <div className={"d-flex justify-content-between justify-content-xl-end align-items-center"}>
                        {can('create', 'job') && (
                            <Button
                                label={"Upload Document"}
                                icon={"far fa-plus-circle"}
                                classes={"btn btn-eh-lilac px-3 m-0"}
                                onClick={() => setUploadFileModal(true)}
                            />
                        )}
                    </div>
                </div>
                <div className="col-12 col-xl-6 m-0 p-0 pr-xl-2 order-xl-1 d-flex justify-content-start align-items-center">
                    <SearchInput
                        value={searchTerm}
                        classes={""}
                        placeholder={"Search..."}
                        onChange={(value) => setSearchTerm(value)}
                    />
                </div>
            </div>
            <div className={"file-gallery row"}>
                {!!files && files.length > 0 ? files.map((file) => (
                    <Tile
                        key={file.id}
                        file={file}
                        onDelete={(file) => setDeleteFileModal(file)}
                    />
                )) : (
                    <NoFiles
                        message={"No Documents"}
                    />
                )}
            </div>
            <UploadFileModal
                show={uploadFileModal}
                parentId={parentId}
                onCancel={() => setUploadFileModal(false)}
                onComplete={(files) => handleFilesUpload(files)}
                singleItemLabel={"Document"}
                multiItemLabel={"Documents"}
            />
            <DeleteFileModal
                show={!!deleteFileModal}
                file={!!deleteFileModal ? deleteFileModal : null}
                parentId={parentId}
                onCancel={() => setDeleteFileModal(null)}
                onConfirm={(file) => handleFileDelete(file)}
            />
        </Card>
    );
}

export default FileGallery;
